import {
  Card,
  CardBody,
  CardHeader,
  Heading,
  Icon,
  IconButton,
  Image,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { useTrackingContext } from '../../../providers/tracking'
import { useSelector } from 'react-redux'
import { selectCorporateProfileId } from '../../../store/selectors/customerProfile'
import { Link } from 'react-router-dom'
import { RootState } from '../../../types/rootState'
import { useEffect, useState } from 'react'
import GiftCardImage from '../../../assets/homes/img/16x9-100-dollar-gift-card.svg'

interface SurveyFlagPayload {
  // object key is corporateProfileId
  [key: string]: SurveyDisplayData
}
interface SurveyDisplayData {
  enabled: boolean
  linkText: string
  afterLinkText: string
  headerText: string
  surveyLinkUrl: string
  corporateProfileName: string
}

export const SurveyPopup = () => {
  const { experiment } = useTrackingContext()
  const corporateProfileId = useSelector<RootState, string>(selectCorporateProfileId)

  // NOTE - this feature was quickly hacked in for a single customer because we didn't have budget for Intercom
  // if client surveys become something we do commonly, we should strongly consider paying for a prebuilt solution (FreshDesk, Intercom, etc)
  // or spend more time cleaning up rough edges here

  // flag payload can be modified here:
  // https://experiment.amplitude.com/homebot/411737/config/75412/configure
  // payload is an object where the key is the corporateProfileId and values are the text to display, google form link url, as well as an "enabled" boolean
  // this lets us enable/disable the survey for specific corporate profiles
  // toggling off the flag in amplitude will disable the survey for all corporate profiles

  const [surveyDisplayData, setSurveyDisplayData] = useState<SurveyDisplayData | undefined>(undefined)

  const [surveyFlagIsOn, setSurveyFlagIsOn] = useState(false)
  const [surveyDismissed, setSurveyDismissed] = useState(false)

  useEffect(() => {
    const surveyPayload: SurveyFlagPayload = experiment?.variant('enable-survey')?.payload
    if (surveyPayload && surveyPayload[corporateProfileId]) {
      setSurveyDisplayData(surveyPayload[corporateProfileId])
    }
    if (experiment?.variant('enable-survey')?.value === 'on') {
      setSurveyFlagIsOn(true)
    }
  }, [experiment, corporateProfileId])

  if (surveyDismissed || !surveyFlagIsOn || !surveyDisplayData?.enabled) {
    return null
  }

  return (
    <Card
      size='sm'
      position='fixed'
      zIndex={100}
      bottom={[3, 3, 4]}
      left={['1.25%', '50%', 4]}
      marginLeft={['initial', '-170px', 'initial']}
      width={['97.5%', 340, 340]}
      maxWidth={['auto', 340, 340]}
      overflow='hidden'
    >
      <CardHeader display='flex' margin={-3}>
        <Image src={GiftCardImage} aria-hidden='true' alt='' />
        <IconButton
          onClick={() => setSurveyDismissed(true)}
          variant='ghost'
          size='sm'
          aria-label='Dismiss survey'
          icon={<Icon name='times' />}
          position='absolute'
          top={['3', '2', '3']}
          right={['3', '2', '3']}
        />
      </CardHeader>
      <CardBody>
        <Heading fontWeight='semibold' size='xs' textAlign='left'>
          {surveyDisplayData?.headerText}
        </Heading>
        <Text size={['2xs', 'xs', '2xs']}>
          <Link
            style={{ color: '#76b8ee' }}
            to={{
              pathname: surveyDisplayData?.surveyLinkUrl
            }}
            target='_blank'
          >
            {surveyDisplayData?.linkText}{' '}
          </Link>
          {surveyDisplayData?.afterLinkText}
        </Text>
      </CardBody>
    </Card>
  )
}
